var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m63 1h-62v52h33v10h21v-10h8zm-2 8h-12v-6h12zm-14-6v6h-44v-6zm6 58h-3v-13h-2v13h-12v-9.913c0-1.693-1.209-3.142-2.874-3.443l-3.199-.582c-2.855-.52-4.927-3.002-4.927-5.904v-11.658c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v9.5c0 2.206 1.794 4 4 4h4.22l2.238 8.956 3.542-3.542 3.542 3.542 2.05-8.203c3.179 1.39 5.408 4.561 5.408 8.247zm-16-25c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm5 9.197-1.464-2.197h2.929zm-2.458 2.847-1.172-4.687 2.343 3.515zm6.087-4.686-1.171 4.686-1.171-1.171zm9.32 7.642c-.43-4.739-3.877-8.611-8.401-9.69 1.498-1.285 2.452-3.187 2.452-5.31 0-3.86-3.141-7-7-7s-7 3.14-7 7c0 1.958.81 3.728 2.111 5h-5.111c-1.103 0-2-.897-2-2v-9.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v11.658c0 3.868 2.763 7.179 6.569 7.87l3.199.583c.684.124 1.175.703 1.216 1.389h-30.984v-40h58v40z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.293 30.293-3.293 3.293v-.586h-12v12h12v-8.586l4.707-4.707zm-5.293 12.707h-8v-8h8v.586l-4 4-2.293-2.293-1.414 1.414 3.707 3.707 4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17 19.586v-.586h-12v12h12v-8.586l4.707-4.707-1.414-1.414zm-2 9.414h-8v-8h8v.586l-4 4-2.293-2.293-1.414 1.414 3.707 3.707 4-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m33 21h26v2h-26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33 25h26v2h-26z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m57 29h2v2h-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m53 29h2v2h-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m49 29h2v2h-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m41 51h2v2h-2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m41 55h2v2h-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m5 5h2v2h-2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m9 5h2v2h-2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m13 5h2v2h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt4);
export default __webpack_public_path__ + "static/media/IT4.3d84e1bd.svg";
export { ForwardRef as ReactComponent };